import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { readValueFromConfig } from '../../lib/util';
import { PushService} from '../../service/PushService';
import { AppVersion } from '@ionic-native/app-version';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})

export class AboutPage {
  public version: any = "?";
  public dados: any;
  public idDevice: number;

  constructor(public navCtrl: NavController, public params: NavParams, pushService : PushService, appVersion: AppVersion) {
    let th = this;
    appVersion.getVersionNumber().then((version) => {
      th.version = version;
    }).catch(() => {
    });
    this.idDevice = readValueFromConfig(pushService.localStorageKeyName(), 'idDevice');
    this.dados = params.get('dados');
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts